module.exports = __webpack_public_path__ + "static/hp_sponsorship_motorsport-524bb8541ab1dc1e335b086e64a4e811.jpg";